import { Component } from '@angular/core';
import { UtilityHelper } from '../../../../core/helper/utility-helper';
import { Router, RouterLink } from '@angular/router';
import { WebService } from '../../../../core/services/web-service/web.service';
import { environment } from '../../../../../environments/environment';
import { CommonModule } from '@angular/common';
declare var $: any;
@Component({
  selector: 'app-cat-subcat-list',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './cat-subcat-list.component.html',
  styleUrl: './cat-subcat-list.component.scss'
})
export class CatSubcatListComponent {
 isLoading: boolean = true;
  DataList: any[] = [];
  imageBaseUrl = environment.imageBaseUrl;
  isSliderInitialized = false;
  constructor(
    private utility: UtilityHelper,
    private router: Router,
    private WebService: WebService
  ) {}
  encryptId(id: any): string {
    return this.utility.encryptLinkParams(id.toString());
  }
  navigateToShopDetail(categoryId: string, subCategoryId: string,dynamicSlug: string): void {
    const encryptedId = this.encryptId(categoryId);
    const encryptedSubCatId = this.encryptId(subCategoryId);
    this.router.navigate([`cn/${dynamicSlug}`, encryptedId,encryptedSubCatId]);
  }
  navigateToCatSubList(dynamicSlug: string): void {
    this.router.navigate([`cat/sb/${dynamicSlug}`]);
  }

  ngOnInit() {
    this.getCategoryListData();
     this.WebService.subcategoryDatalist$.subscribe((data) => {
      if (data?.status === 200) {
        this.DataList = data.data;
      } else {
        this.DataList = [];
      }
    });
  }

  getCategoryListData() {
    this.isLoading = true;
    this.WebService.getCategorySubCatList().subscribe((response: any) => {
      if (response?.status == 200) {
        // this.DataList = response.data;
        this.WebService.subcategoryData(response);
      } else {
        this.DataList = [];
      }
      this.isLoading = false;
    });
  }

}
